<form [formGroup]="Form">
    <textarea rows="5" class="form-control" formControlName="coquti_tx_description" placeholder="Ingrese un titulo a la encuesta"></textarea>
    <br>
    <button class="btn btn-badminton btn-sm pull-right" (click)="SaveQuizTitle()" >Guardar</button>
</form>
